import EventCalendar from "../components/EventCalendar";
import { FaRegUserCircle,FaRegCheckCircle, FaBirthdayCake, FaUserFriends, FaStar, FaRegHeart, FaHeart } from "react-icons/fa";
import { IoCalendarOutline } from "react-icons/io5";
import { CiCalendar } from "react-icons/ci";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../context/UserContext";
import { useContext, useEffect, useState } from "react";
import { base_url } from '../url_variables';
import axios from 'axios';
import { useCookies } from "react-cookie";
import { GridLoader } from "react-spinners";
import {TopBar} from '../components/topbar';
import { MenuContext } from "../context/MenuContext";
import { ReviewModal } from "../components/review_modal";
import { TransactionModal } from "../components/transaction_modal";
import { TbPigMoney } from "react-icons/tb";
import { BiMoneyWithdraw } from "react-icons/bi";


export default function CashFlow() {
    const navigate = useNavigate();
    const {userProfile, logOutFunction} = useContext(UserContext);
    const [cookies] = useCookies();
    const [formFields, setFormFields] = useState({});
    const [bookingList, setBookingList] = useState([]);
    const [pageLoading, setPageLoading] = useState(true);
    const [offset, setOffset] = useState(0);
    const [pagination, setPagination] = useState('');
    const { menuOpen, setMenuOpen } = useContext(MenuContext)
    const [showTransactionModal, setShowTransactionModal] = useState(false);
    const [apartmentReview, setApartmentReview] = useState({});
    const [pageData, setPageData] = useState({});

    useEffect(() => {
        if (menuOpen) setMenuOpen(false);
        getData();
    }, [])

    useEffect(() => {
        getData();
    }, [offset])

    function changePage(type) {
        if (type == "next") {
            setOffset(offset + 20);
        } else {
            setOffset(offset - 20);
        }
    }

    async function getData() {
        const formData = new FormData();
        Object.entries(formFields).forEach(([key, value]) => {
          formData.append(key, value);
        });
        formData.append('offset', offset);
        setPageLoading(true)
        try {
            const response = await axios.post(base_url + '/cash-flow.php', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                    accountid: cookies?.userProfile?.main_id,
                },
            });
            if (response.data.code == 403) {
                logOutFunction()
            }
            setPageLoading(false)
            if (response.data.status) {
              setBookingList(response.data.records);
              setPageData({ branches: response.data.branches, apartments: response.data.apartments, total_income: response.data.total_income, total_expense: response.data.total_expense });
            } else {

            }
        } catch (error) {
          setPageLoading(false)
        }
    }

  return (
    <div className="flex flex-col rounded-[10px] min-h-full bg-white">
      {showTransactionModal &&
            <TransactionModal 
                setShowTransactionModal={setShowTransactionModal}
                getData={getData}
                pageData={pageData}
            />
      }
      {pageLoading && (
      <div className="flex items-center justify-center h-full w-[-webkit-fill-available] z-[99] bg-[#ffffff] fixed opacity-[0.9]">
        <GridLoader
            color={'#037684'}
            loading={true}
            size={20}
            aria-label="Loading Spinner"
            data-testid="loader"
        />
      </div>
      )}
        {/* <h2 className="text-2xl text-[#037684] font-bold mb-4">Welcome, {userProfile?.name}</h2> */}
        <TopBar title={`Welcome, ${cookies?.userProfile?.name}`} />
        <div className="py-6 px-6 flex flex-col justify-start">
            <div className="animate-fadeIn mt-0 w-full bg-white rounded-3xl border p-6 shadow-sm grid grid-cols-2 md:grid-cols-2">
                <div className="flex-1">
                  <label className="flex items-center gap-2 text-gray-500 text-sm mb-1">
                    <TbPigMoney className="w-5 h-5" />
                    Revenue
                  </label>

                  <div className="relative">
                      <p className="font-bold text-3xl">{pageData?.total_income}</p>
                  </div>
                </div>
                <div className="flex-1">
                  <label className="flex items-center gap-2 text-gray-500 text-sm mb-1">
                    <BiMoneyWithdraw className="w-5 h-5" />
                    Expenses
                  </label>

                  <div className="relative">
                      <p className="font-bold text-3xl">{pageData?.total_expense}</p>
                  </div>
                </div>
            </div>
            <div className="flex mt-7 flex-row items-center justify-between">
                <h2 className="text-xl md:text-2xl text-black font-bold">{'Cash Flow'}</h2>
                <button onClick={() => setShowTransactionModal(true) } className="bg-primary text-white flex flex-row items-center justify-evenly w-auto h-[35px] px-5 rounded-xl shadow-md shrink-0 text-sm md:text-md font-cormorant-bold">
                    <span className="text-white font-cormorant-bold text-sm md:text-md update-price">Record Transaction</span>
                </button>
            </div>
            <div className='overflow-x-auto mt-5'>
                <table className="w-full table-auto border-collapse text-sm md:text-[15px]">
                    <thead className="bg-gray-50 border-b">
                    <tr>
                        <th className="hidden md:table-cell px-2 py-4">
                            <div className="flex items-center gap-1">#</div>
                        </th>
                        <th className="text-left px-2 py-4 font-medium text-gray-600">
                            <div className="flex items-center gap-1">Branch</div>
                        </th>
                        <th className="text-left px-2 py-4 font-medium text-gray-600">
                            <div className="flex items-center gap-1">Apartment</div>
                        </th>
                        <th className="text-left px-2 py-4 font-medium text-gray-600">
                            <div className="flex items-center gap-1">Total Paid</div>
                        </th>
                        <th className="hidden md:table-cell text-left px-2 py-4 font-medium text-gray-600">
                            <div className="flex items-center gap-1">Booking Amount</div>
                        </th>
                        <th className="text-left px-2 py-4 font-medium text-gray-600">
                            <div className="flex items-center gap-1">Tax</div>
                        </th>
                        <th className="text-left px-2 py-4 font-medium text-gray-600">
                            <div className="flex items-center gap-1">Narration</div>
                        </th>
                        <th className="text-left px-2 py-4 font-medium text-gray-600">
                            <div className="flex items-center gap-1">Type</div>
                        </th>
                        <th className="text-left px-2 py-4 font-medium text-gray-600">
                            <div className="flex items-center gap-1"></div>
                        </th>
                        <th className="hidden md:table-cell text-left px-2 py-4 font-medium text-gray-600">
                            <div className="flex items-center gap-1">Time</div>
                        </th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody className="text-gray-700">
                        {bookingList?.map((row, index) => (
                            <tr
                            key={index}
                            className={index % 2 === 0 ? "bg-white animate-fadeIn" : "bg-gray-50 animate-fadeIn"}
                            >
                                <td className="hidden md:table-cell px-2 py-2">
                                    {++index}
                                </td>
                                <td className="px-2 py-2 font-semibold">
                                    {row.branch_name}
                                </td>
                                <td className="px-2 py-2 font-semibold">
                                    {row.apt_name}
                                </td>
                                <td className="px-2 py-2">
                                    {row.total_amount}
                                </td>
                                <td className="hidden md:table-cell px-2 py-2">
                                    {row.booking_amount}
                                </td>
                                <td className="px-2 py-2">
                                    {row.tax_amount}
                                </td>
                                <td className="px-2 py-2">
                                    {row.narration}
                                </td>
                                <td className={`px-2 py-2 ${row.transaction_type == "CREDIT" ? 'text-[#00b47a]' : 'text-[#ff0000]'}`}>
                                    {row.transaction_type}{" "}({row.recorded_by})
                                </td>
                                <td className="hidden md:table-cell px-2 py-2">
                                    {row.time }
                                </td>
                                <td className="px-2 py-2">
                                    {row.rrr !== "" && <div className="flex flex-col md:flex-row gap-y-1 md:gap-y-0 gap-x-1">
                                        <div onClick={() => navigate(`/dashboard/reservation-success/${row.apt_id}/${row.rrr}`)} className="flex items-center justify-center cursor-pointer px-2 py-1 md:px-3 md:py-2 rounded-[5px] border border-1 border-primary bg-primary text-white font-semibold text-center text-xs">{'View'}</div>
                                    </div>}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className='w-full flex justify-end mt-6'>
                <div className='flex flex-col items-center'>
                    <div className="flex items-center space-x-2 border border-gray-300 rounded-lg px-1 py-1 w-fit bg-white">
                        <button
                            onClick={() => changePage('prev')}
                            className="text-sm font-semibold px-3 py-1 rounded bg-gray-100 hover:bg-gray-200"
                        >
                            Prev.
                        </button>
                        <button
                            onClick={() => changePage('next')}
                            className="text-sm font-semibold px-3 py-1 rounded bg-gray-100 hover:bg-gray-200"
                        >
                            Next
                        </button>
                    </div> 
                    <label className='text-sm mt-2'>{pagination}</label>
                </div>
            </div>
        </div>
    </div>
  );
}
